/**
 * Copy do assistente e o que ele promete.
 *
 * Compliance está aqui desde 13/10/2026 — o backend (`main_atendimento.py`)
 * ganhou o roteamento pro Especialista Compliance em 08/10/2026; esta cópia
 * ficou pra trás até agora. O shot `1j` já antecipava os três módulos no
 * subtítulo e um chip de compliance, então isto alinha o código ao shot, não
 * diverge dele.
 */
export const TEXTOS = {
  titulo: 'Assistente IOX',
  abrir: 'abrir assistente de IA',
  minimizar: 'minimizar',
  fechar: 'fechar e encerrar conversa',
  enviar: 'enviar',
  campo: 'Pergunte sobre seus dados...',
  conversa: 'Conversa',
  consultando: 'consultando…',
  novaResposta: 'Nova resposta do assistente',
  novoAviso: 'O assistente não conseguiu responder',
  semResposta: 'Não foi possível obter uma resposta agora. Tente de novo.',
  tempo: 'A resposta demorou mais do que o esperado. Tente de novo.',
  limite: 'Você atingiu o limite de mensagens por enquanto. Tente de novo em alguns minutos.',
} as const

/** Teto do campo — o mesmo do backend, que responde 400 `MENSAGEM_LONGA` acima disso. */
export const LIMITE_DE_CARACTERES = 4000

/** O subtítulo do painel, na ordem do `1j`. Cada entrada some com a flag do módulo. */
export const ESPECIALIDADES = [
  { flag: 'modulo.finops', rotulo: 'FinOps' },
  { flag: 'modulo.orcamento', rotulo: 'Orçamento' },
  { flag: 'modulo.compliance', rotulo: 'Compliance' },
] as const

/** Os chips do `1j`, na ordem do shot. ⚠️ O vínculo chip → módulo é leitura nossa (§9). */
export const SUGESTOES = [
  { flag: 'modulo.orcamento', texto: 'custos do mês fiscal' },
  { flag: 'modulo.finops', texto: 'oportunidades abertas' },
  { flag: 'modulo.compliance', texto: 'progresso da minha autoavaliação' },
] as const

const ROTULO_DO_ESPECIALISTA: Record<string, string> = {
  especialista_finops: 'FinOps',
  especialista_orcamentario: 'Orçamentário',
  especialista_compliance: 'Compliance',
}

/**
 * A linha sob a resposta: quem o agente coordenador consultou de fato.
 *
 * Um valor desconhecido é IGNORADO, e não exibido cru: o backend pode ganhar um
 * especialista antes de o front saber o nome dele.
 */
export function atribuicao(especialistasAcionados: readonly string[]): string {
  const rotulos = [
    ...new Set(
      especialistasAcionados
        .map((especialista) => ROTULO_DO_ESPECIALISTA[especialista])
        .filter((rotulo): rotulo is string => rotulo !== undefined),
    ),
  ]

  if (rotulos.length === 0) return 'agente coordenador'
  if (rotulos.length === 1) return `Especialista ${rotulos[0]} · consulta via agente coordenador`
  return `Especialistas ${rotulos.slice(0, -1).join(', ')} e ${rotulos.at(-1)} · consulta via agente coordenador`
}
